import Box from "@mui/material/Box";
import ButtonBase from "@mui/material/ButtonBase";
import Typography from "@mui/material/Typography";
import { layoutTerms, WordTerm } from "./wordCloudLayout";

export type WordCloudProps = { terms: WordTerm[]; onTermClick?: (term: string) => void; ariaLabel: string; emptyText?: string; limit?: number };

const BOLD_FROM_PX = 26;

// Nuvem própria (A14): frequências vêm do BE; o maior termo primeiro, em flex-wrap centralizado (final-g1-conversao.png).
export function WordCloud({ terms, onTermClick, ariaLabel, emptyText = "Nenhum texto no período", limit }: WordCloudProps) {
  const items = layoutTerms(terms, limit);
  if (items.length === 0) return <Typography variant="body2" color="text.secondary">{emptyText}</Typography>;
  return (
    <Box role="group" aria-label={ariaLabel} sx={{ display: "flex", flexWrap: "wrap", justifyContent: "center", alignItems: "baseline", gap: "4px 10px", py: "8px" }}>
      {items.map((t) => (
        <ButtonBase key={t.term} aria-label={`${t.term} (${t.count})`} title={`${t.term}: ${t.count}`} onClick={() => onTermClick?.(t.term)} disabled={!onTermClick}
          style={{ fontSize: `${t.size}px`, color: t.color, fontWeight: t.size >= BOLD_FROM_PX ? 700 : 500, lineHeight: 1.1 }}
          sx={{ borderRadius: "4px", "&:hover": { textDecoration: "underline" } }}>
          {t.term}
        </ButtonBase>
      ))}
    </Box>
  );
}
